import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { Baseurl } from "../../config/BaseUrl";
import {
  setPropertybySubcatStatus,
  setPropertyfilterbySubcat,
} from "../../redux/property/PropertySlice";
import { 
  FaHome, 
  FaCalendarCheck, 
  FaRocket, 
  FaBuilding 
} from "react-icons/fa";
import { 
  FiArrowUpRight, 
  FiZap, 
  FiCalendar, 
  FiTrendingUp, 
  FiClock 
} from "react-icons/fi";
import "./MoveInNowNew.css";

const MoveInNow = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const supcat = "Residential";
  const cat = "Buy";
  const subcat1 = "All";
  const city = "Hyderabad";

  const [readttomoveCount, setReadttomoveCount] = useState([]);
  const [underconsCount, setUnderconsCount] = useState([]);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [readyRes, underRes] = await Promise.allSettled([
          axios.get(`${Baseurl}/api/v1/property/propertybyavailibility/${city}/Ready to move`),
          axios.get(`${Baseurl}/api/v1/property/propertybyavailibility/${city}/Under Construction`),
        ]);

        if (readyRes.status === "fulfilled" && readyRes.value.data?.success) {
          setReadttomoveCount(readyRes.value.data.propertybyAvailability || []);
        }
        if (underRes.status === "fulfilled" && underRes.value.data?.success) {
          setUnderconsCount(underRes.value.data.propertybyAvailability || []);
        }
      } catch (error) {
        // Fallbacks rendered seamlessly
      }
    };

    fetchCounts();
  }, [city]);

  const handleCardClick = (dataList) => {
    dispatch(setPropertybySubcatStatus(true));
    dispatch(setPropertyfilterbySubcat(dataList));
    navigate(`/property-search/${supcat}/${cat}/${subcat1}/${city}`);
  };

  const possessionCards = [
    {
      id: "ready-to-move",
      title: "Ready to Move",
      timeline: "Immediate Possession",
      count: `${readttomoveCount.length > 0 ? readttomoveCount.length : 30}+ Properties`,
      badgeText: "Ready Now",
      badgeIcon: <FiZap />,
      image: "/assets/images/possession/possession_ready_to_move.jpg",
      themeClass: "mgh-pos-rose",
      icon: <FaHome />,
      dataList: readttomoveCount,
    },
    {
      id: "possession-2023",
      title: "In 1 Year",
      timeline: "Possession by 2025",
      count: `${underconsCount.length > 0 ? underconsCount.length : 30}+ Properties`,
      badgeText: "Under Construction",
      badgeIcon: <FiCalendar />,
      image: "/assets/images/possession/possession_under_construction.jpg",
      themeClass: "mgh-pos-blue",
      icon: <FaCalendarCheck />,
      dataList: underconsCount,
    },
    {
      id: "possession-2024",
      title: "In 2 Years",
      timeline: "Possession by 2026",
      count: "35+ Properties",
      badgeText: "New Launches",
      badgeIcon: <FiTrendingUp />,
      image: "/assets/images/possession/possession_new_launch.jpg",
      themeClass: "mgh-pos-green",
      icon: <FaRocket />,
      dataList: underconsCount,
    },
    {
      id: "possession-2025",
      title: "In 3+ Years",
      timeline: "Possession Beyond 2026",
      count: "25+ Properties",
      badgeText: "Future Investment",
      badgeIcon: <FiClock />,
      image: "/assets/images/possession/possession_future_invest.jpg",
      themeClass: "mgh-pos-amber",
      icon: <FaBuilding />,
      dataList: underconsCount,
    },
  ];

  return (
    <section className="mgh-possession-section" aria-label="Explore Projects by Possession Timeline">
      {/* Header Area */}
      <div className="mgh-possession-header">
        <div className="mgh-possession-header-left">
          <div className="mgh-possession-eyebrow">
            <span>CHOOSE BY POSSESSION</span>
            <span className="mgh-possession-eyebrow-line"></span>
          </div>
          <h2 className="mgh-possession-title">
            Move in <span className="mgh-possession-highlight">now,</span> next year or later
          </h2>
          <p className="mgh-possession-subtitle">
            Explore verified projects based on your preferred possession timeline in {city}.
          </p>
        </div>

        {/* Decorative Skyline Graphic */}
        <div className="mgh-possession-header-right" aria-hidden="true">
          <div className="mgh-possession-decor-skyline"></div>
          <img
            src="/assets/images/possession/possession_ready_to_move.jpg"
            alt=""
            className="mgh-possession-decor-building"
          />
          <div className="mgh-possession-script-wrap">
            <span className="mgh-possession-script-text">
              Your<br />Future Home<br />Awaits
            </span>
            <svg className="mgh-possession-script-arrow" viewBox="0 0 55 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 8 C 20 -4, 38 4, 46 26" stroke="#c8872b" strokeWidth="2.2" strokeLinecap="round" fill="none" />
              <path d="M38 23 L 46 27 L 49 18" stroke="#c8872b" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </svg>
          </div>
        </div>
      </div>

      {/* 4 Clean Possession Cards */}
      <div className="mgh-possession-grid">
        {possessionCards.map((card) => (
          <div
            key={card.id}
            className={`mgh-possession-card ${card.themeClass}`}
            onClick={() => handleCardClick(card.dataList)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleCardClick(card.dataList);
              }
            }}
          >
            {/* Top Image Viewport with Floating Badges */}
            <div className="mgh-possession-img-wrap">
              <img
                src={card.image}
                alt={card.title}
                className="mgh-possession-img"
                loading="lazy"
                onError={(e) => {
                  e.target.src = "/assets/images/sliderImg/d_hp_availability_2.webp";
                }}
              />
              <div className="mgh-possession-img-overlay"></div>

              {/* Top Floating Status Badge */}
              <div className="mgh-pos-floating-badge">
                <span className="mgh-pos-badge-icon">{card.badgeIcon}</span>
                <span>{card.badgeText}</span>
              </div>

              {/* Top Right Floating Action Arrow */}
              <div className="mgh-pos-arrow-btn" aria-label={`Explore ${card.title}`}>
                <FiArrowUpRight />
              </div>
            </div>

            {/* Card Body */}
            <div className="mgh-possession-card-body">
              <div className="mgh-pos-title-row">
                <div className="mgh-pos-icon-circle" aria-hidden="true">
                  {card.icon}
                </div>
                <div className="mgh-pos-title-text">
                  <h3 className="mgh-pos-title">{card.title}</h3>
                  <span className="mgh-pos-timeline">{card.timeline}</span>
                </div>
              </div>

              {/* Bottom Count Pill */}
              <div className="mgh-pos-bottom-row">
                <span className="mgh-pos-count-pill">{card.count}</span>
                <span className="mgh-pos-city-tag">Hyderabad</span>
              </div>
            </div>

            {/* Bottom Thematic Accent Line */}
            <div className="mgh-pos-accent-line"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MoveInNow;
